/**
 * Which vocabulary a ŠGP sub-activity classifier makes the activity answer "which species?" in.
 * Mirrors the backend `SgpSpeciesDeclarationKind` enum, stored as an `int` column on
 * `clsf_sgp_sub_activity`.
 */
export enum SgpSpeciesDeclarationKind {
	/** The sub-activity asks for no species at all. */
	None = 0,

	/** The external animal GK tree. */
	GkAnimals = 1,

	/** The processed-protein source species, with every source on offer. */
	ProteinSource = 2,

	/** The feed targets the produktas permits, and the protein-source species, with every source on offer. */
	FeedTargetAndProteinSource = 3,
}
